import axios from 'axios'
const proxyConfig = require('../config/config');
const API_CLIENT  = axios.create({
    baseURL: `${proxyConfig.ip_proxy + ':' + proxyConfig.port_proxy + '/' + proxyConfig.subPath + proxyConfig.restricted_area}/`,
    timeout: proxyConfig.requestTimeout
});
const API3_CLIENT = axios.create({
    baseURL: `https://${window.location.host}/api3/`,
    timeout: proxyConfig.requestTimeout
});
export default {
    async getFromAxios({locale}, {path, method, params_}) {
        let ax = axios.create({
            baseURL: path,
            timeout: proxyConfig.requestTimeout
        });

        console.log('method', method)

        try {
            ax.defaults.headers["Locale"] = locale;
            ax.defaults.headers["Accept-Language"] = "en-US,en;";
            ax.defaults.headers["accept"] = 'application/json';
            ax.defaults.headers["Content-Type"] = params_ ? 'application/json; charset=UTF-8' : 'application/x-www-form-urlencoded';
            // API_CLIENT.defaults.headers["Authorization"] = 'Bearer ' + (isNewAccount ? singleAccessToken : t);

            return await ax.get();
        } catch (e) {
            if (e.response && e.response.data && e.response.data['oauth2'])
                throw "500";
            else
                throw e;
        }
    },
    async getFromProxy({locale, singleAccessToken, accessToken}, {path, method, params_, isNewAccount, token, onDownloadProgress}) {
        try {
            let t = accessToken || token
            API_CLIENT.defaults.headers["Locale"] = locale;
            API_CLIENT.defaults.headers["Content-Type"] = params_ ? 'application/json; charset=UTF-8' : 'application/x-www-form-urlencoded';
            API_CLIENT.defaults.headers["Authorization"] = 'Bearer ' + (isNewAccount ? singleAccessToken : t);
            API_CLIENT.defaults.onDownloadProgress = onDownloadProgress;
            if (['post', 'put'].includes(method))
                return await API_CLIENT[method](path, JSON.stringify(params_));
            return await API_CLIENT.get(path);
        } catch (e) {
            if (e.response && e.response.data && e.response.data['oauth2'])
                throw "500";
            else
                throw e;
        }
    },
    async getFromApi3({locale, accessTokenApi3}, {path, method, params_, headers, onDownloadProgress}) {
        try {
            API3_CLIENT.defaults.headers["Locale"] = locale;
            API3_CLIENT.defaults.headers["Content-Type"] = 'application/json';
            // API3_CLIENT.defaults.headers["Content-Type"] = params_ ? 'application/json; charset=UTF-8' : 'application/x-www-form-urlencoded';
            API3_CLIENT.defaults.headers["Authorization"] = 'Bearer ' + accessTokenApi3;
            API3_CLIENT.defaults.headers["accept"] = 'application/json';
            API3_CLIENT.defaults.onDownloadProgress = onDownloadProgress;

            if(headers !== undefined) {
                if(headers['x-otp-check'] !== undefined ) {
                    API3_CLIENT.defaults.headers["x-otp-check"] = headers['x-otp-check'];
                }
            }

            if (['post', 'put'].includes(method))
                return await API3_CLIENT[method](path, JSON.stringify(params_));
            return await API3_CLIENT.get(path);
        } catch (e) {
            if (e.response && e.response.data && e.response.data['oauth2'])
                throw "500";
            else
                throw e?.response?.data;
        }
    },
    async getFromApi3Unauth({locale}, {path, method, params_, headers, onDownloadProgress}) {
        try {
            API3_CLIENT.defaults.headers["Locale"] = locale;
            API3_CLIENT.defaults.headers["Content-Type"] = 'application/json';
            API3_CLIENT.defaults.headers["accept"] = 'application/json';
            if(headers !== undefined)
                if(headers['x-otp-check'] !== undefined ) {
                    API3_CLIENT.defaults.headers["x-otp-check"] = headers['x-otp-check'];
                }
            API3_CLIENT.defaults.onDownloadProgress = onDownloadProgress;
            if (['post', 'put'].includes(method))
                return await API3_CLIENT[method](path, JSON.stringify(params_));
            return await API3_CLIENT.get(path);
        } catch (e) {
            if (e.response && e.response.data && e.response.data['oauth2'])
                throw "500";
            else
                throw e;
        }
    }
}
